const firstNameOf = (name: string): string => name.trim().split(/\s+/)[0] ?? name;

export const shortNames = (names: readonly string[], everyone: readonly string[] = names): string[] => {
    const counts = new Map<string, number>();
    new Set([...everyone, ...names].map(name => name.trim())).forEach(name => {
        const first = firstNameOf(name);
        counts.set(first, (counts.get(first) ?? 0) + 1);
    });
    return names.map(name => {
        const first = firstNameOf(name);
        return (counts.get(first) ?? 0) > 1 ? name.trim() : first;
    });
};

export type PeopleSummary =
    | {readonly kind: 'none'}
    | {readonly kind: 'list'; readonly names: readonly string[]}
    | {readonly kind: 'more'; readonly names: readonly string[]; readonly more: number};

export const summarizePeople = (names: readonly string[], max: number, everyone: readonly string[] = names): PeopleSummary => {
    const short = shortNames(names, everyone);
    if (short.length === 0) {
        return {kind: 'none'};
    }
    if (short.length <= max) {
        return {kind: 'list', names: short};
    }
    return {kind: 'more', names: short.slice(0, max), more: short.length - max};
};
